
	<footer class="footer">
		<div class="content has-text-centered OrdersView__Copyrights">
			<p>
				&copy; {{ currentYear }}
				Route Planner |
        Opieka techniczna:
        <a href="https://trustdeal.pl">
          <img src="/img/trustdeal.svg" alt="Trust Deal" style="height: 13px" />
        </a>
			</p>
		</div>
	</footer>
